<template>
	<div class="container">
		<div class="col__box">
			
		</div>
	</div>
</template>

<script>
	export default {

		name: 'vtv-index',

		data () {
			return {
				
			}
		}
	}
</script>

<style lang="css" scoped>
</style>